<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>
          {{ isEditing ? 'Editar Transporte' : 'Crear Transporte de Personal' }}
        </v-toolbar-title>
      </v-toolbar>

      <v-card-text class="pt-4">
        <v-form ref="form" v-model="formValid">
          <v-text-field
            v-model="formData.name"
            label="Nombre del Transporte"
            required
            :rules="[v => !!v || 'El nombre es requerido']"
            class="mb-3"
          ></v-text-field>

          <v-text-field
            v-model="formData.plate"
            label="Placa del Vehículo"
            required
            :rules="[v => !!v || 'La placa es requerida']"
            class="mb-3"
          ></v-text-field>

          <v-text-field
            v-model="formData.driver_name"
            label="Nombre del Conductor"
            required
            :rules="[v => !!v || 'El nombre del conductor es requerido']"
            class="mb-3"
          ></v-text-field>

          <v-text-field
            v-model="formData.driver_last_name"
            label="Apellidos del Conductor"
            required
            :rules="[v => !!v || 'Los apellidos son requeridos']"
            class="mb-3"
          ></v-text-field>

          <v-text-field
            v-model.number="formData.capacity"
            type="number"
            label="Capacidad de Pasajeros"
            required
            :rules="[v => !!v || 'La capacidad es requerida']"
            class="mb-3"
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="cancel"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          @click="save"
        >
          {{ isEditing ? 'Actualizar' : 'Crear' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PersonalTransportForm',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    transport: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dialog: false,
      formValid: false,
      loading: false,
      isEditing: false,
      formData: {
        name: '',
        driver_name: '',
        driver_last_name: '',
        plate: '',
        capacity: 0,
        qr_code: ''
      }
    };
  },
  watch: {
    showDialog(val) {
      this.dialog = val;
      if (val && this.transport) {
        this.isEditing = true;
        this.loadTransportData();
      } else if (val) {
        this.isEditing = false;
        this.resetForm();
      }
    },
    dialog(val) {
      if (!val) {
        this.$emit('close');
      }
    }
  },
  methods: {
    loadTransportData() {
      this.formData = {
        ...this.transport,
        qr_code: this.transport.qr_code || ''
      };
    },
    resetForm() {
      this.formData = {
        name: '',
        driver_name: '',
        driver_last_name: '',
        plate: '',
        capacity: 0,
        qr_code: ''
      };
    },
    save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$emit('save', this.formData);
        // El componente padre manejará la lógica y llamará a closeFormDialog después
        this.loading = false;
      }
    },
    cancel() {
      this.dialog = false;
    }
  }
};
</script>

<style scoped>
.mb-3 {
  margin-bottom: 15px;
}
</style>
